<template>
  <div :class="container_class" :style="container_style">
    <multiselect
      @search-change="getSuburbs"
      v-model="suburb"
      @input="updateData"
      @remove="clearData"
      :loading="isLoading"
      :options="suburbs"
      :placeholder="placeholder"
      :clearOnSelect="false"
      :closeOnSelect="true"
      :preserveSearch="true"
      :searchable="true"
      :internal-search="false"
    >
      <template slot="singleLabel" slot-scope="props">
        <div>
          {{
          props.option.state_name+", "+props.option.name+", "+props.option.post_code
          }}
        </div>
      </template>
      <template slot="option" slot-scope="props">
        <div>
          <i class="fa fa-map-marker"></i>
          {{
          props.option.state_name+", "+props.option.name+", "+props.option.post_code
          }}
        </div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "suburb",
  components: {
    Multiselect
  },
  props: {
    place_holder: {
      type: String,
      default: ""
    },
    container_class: {
      type: String,
      default: "form-group skill-formdata home-form-group"
    },
    container_style: {
      type: String,
      default: "form-group skill-formdata"
    },
    value: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      suburb: null,
      suburbs: [],
      placeholder: "Enter a postcode or suburb name",
      isLoading: false,
      searchTimeOut: null
    };
  },
  created() {
    this.Label = this.label;
    if (
      this.place_holder != "" &&
      this.place_holder != null &&
      this.place_holder != undefined
    ) {
      this.placeholder = this.place_holder;
    }
  },
  mounted() {
    this.getSuburbs("");
  },
  methods: {
    getSuburbs: function(searchQuery, id) {
      if (this.searchTimeOut != null) {
        clearTimeout(this.searchTimeOut);
      }
      let self = this;
      self.isLoading = true;

      self.searchTimeOut = setTimeout(function() {
        axios({
          method: "get",
          url: "/api/v1/suburb/search?_method=get&keyword=" + searchQuery
        })
          .then(function(response) {
            self.isLoading = false;
            self.suburbs = response.data.data;
          })
          .catch(function(err) {
            self.isLoading = false;
            self.errors = err.response.data.errors;
          });
      }, 1500);
    },
    updateData: function(value) {
      this.$emit("input", value.id);
      this.$emit("getSuburb", value.name);
      //this.$emit("getCity", value.city_name);
      this.$emit("getState", value.state_name);
      this.$emit("getCountry", value.country_name);
      this.$emit(
        "getLocation",
        value.state_name + ", " + value.name + ", " + value.post_code
      );
    },
    clearData: function() {
      this.$emit("input", null);
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        if (
          this.suburb == null &&
          this.value != null &&
          this.value != undefined &&
          this.value != ""
        ) {
          let self = this;
          self.isLoading = true;
          axios({
            method: "get",
            url: "/api/v1/suburb/search?_method=get&suburb_id=" + self.value
          })
            .then(function(response) {
              self.isLoading = false;
              self.suburb = response.data.data;
              self.$emit(
                "getLocation",
                self.suburb.state_name +
                  ", " +
                  self.suburb.name +
                  ", " +
                  self.suburb.post_code
              );
            })
            .catch(function(err) {
              self.isLoading = false;
              self.errors = err.response.data.errors;
            });
        }
      }
    }
  }
};
</script>
